import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FlexDataLink } from './types';
import { useTopLevelObjectType } from './useTopLevelObjectType';
import { linkQueries } from './linkQueries';

export const useAllFlexDataLinks = (searchTerm: string) => {
  const { topLevelObjectTypes } = useTopLevelObjectType();

  const combinations = useMemo(
    () =>
      topLevelObjectTypes.flatMap(({ dataSourceType, tenantId, objectTypes }) =>
        (objectTypes ?? []).map(({ objectType }) => ({ dataSourceType, tenantId, objectType }))
      ),
    [topLevelObjectTypes]
  );

  const { data, isLoading, isError } = useQuery(linkQueries.search(searchTerm, combinations));

  return { allFlexDataLinks: data ?? ([] as FlexDataLink[]), isLoading, isError };
};
